import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
import { NetworkIcon, ShieldAlertIcon, UserXIcon, TrendingDownIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    title: 'Complex Core Integrations',
    description: 'Legacy systems create costly, fragile connections that slow down innovation and increase maintenance overhead.',
    icon: NetworkIcon
  }, {
    title: 'Quantum Computing Threats',
    description: 'Current encryption standards face obsolescence. "Store now, decrypt later" attacks are already capturing sensitive financial data.',
    icon: ShieldAlertIcon
  }, {
    title: 'Limited Customer Intelligence',
    description: 'Generic product offerings miss individual customer needs, leading to lower conversion rates and diminished loyalty.',
    icon: UserXIcon
  }, {
    title: 'Revenue Leakage',
    description: 'Lucrative micro-lending and P2P opportunities are being lost to agile fintech competitors outside your ecosystem.',
    icon: TrendingDownIcon
  }];
  return <section id="platform" className="py-24 bg-navy relative" data-id="element-496" data-mp="ocg8h378v8rd">
      <div className="max-w-7xl mx-auto px-6" data-id="element-497" data-mp="scqpdawkrjl0">
        <FadeIn className="mb-16 md:w-2/3" data-id="element-498" data-mp="sbyszxv5lhto">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-499" data-mp="x4rw6haz4i3n">
            Traditional Infrastructure Wasn't Built for What's Coming
          </h2>
          <p className="text-xl text-gray-400" data-id="element-500" data-mp="125z3kf97ff9s">
            Financial institutions are caught between maintaining legacy systems
            and defending against next-generation threats, all while losing
            ground to agile fintechs.
          </p>
        </FadeIn>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-501" data-mp="1g2l11p55r23o">
          {problems.map((problem, index) => {
          const Icon = problem.icon;
          return <StaggerItem key={index} data-id="element-502" data-mp="3hv98kaou4bp9" data-mpi={index}>
                <div className="bg-slate border border-white/5 rounded-xl p-8 h-full relative overflow-hidden group hover:border-red-500/30 transition-colors duration-300" data-id="element-503" data-mp="p091nt6ovcfl">
                  {/* Subtle red accent line */}
                  <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-red-500/50 to-transparent opacity-50" data-id="element-504" data-mp="y1gonf3r8qud"></div>

                  <div className="flex items-start gap-5" data-id="element-505" data-mp="txseconqnh5f">
                    <div className="p-3 rounded-lg bg-red-500/10 text-red-400 group-hover:bg-red-500/20 transition-colors duration-300" data-id="element-506" data-mp="17ylafdtoukan">
                      <Icon className="w-6 h-6" data-id="element-507" data-mp="12zihgrqzg4j1" />
                    </div>
                    <div data-id="element-508" data-mp="1hp7lqvudgonj">
                      <h3 className="text-xl font-semibold text-white mb-3" data-id="element-509" data-mp="1hoenkj9hb7h0">
                        {problem.title}
                      </h3>
                      <p className="text-gray-400 leading-relaxed" data-id="element-510" data-mp="1qpcsr4vnll16">
                        {problem.description}
                      </p>
                    </div>
                  </div>
                </div>
              </StaggerItem>;
        })}
        </StaggerContainer>
      </div>
    </section>;
}